import Home from "./Pages/Home/Home";

function App() {
  return (
    <div className="app mt-0">
        <Home/>
    </div>

  );
}

export default App;
